import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_brand_values_all: FaireCategoryEntity = {
  token: "cat_brand-values-all",
  type: "category",
  name: "All brand values",
  level: 2,
  parentToken: "cat_brand-values",
  href: "/category/brand-values",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
